<script setup lang="ts">
import { TableRow } from "@/components/ui/table";

interface Props {
  rows?: number;
  skeletonHeight?: string;
}

withDefaults(defineProps<Props>(), {
  rows: 5,
  skeletonHeight: "h-4",
});
</script>

<template>
  <template v-for="i in rows" :key="`skeleton-${i}`">
    <TableRow :is-loading="true" :skeleton-height="skeletonHeight"> </TableRow>
  </template>
</template>
